var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { Button, useGetList } from "react-admin";
import { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CircularProgress, Typography } from "@mui/material";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAtom } from "jotai";
import archivedElectionEventSelection from "@/atoms/archived-election-event-selection";
import { AuthContext } from "@/providers/AuthContextProvider";
import { IPermissions } from "@/types/keycloak";
import AddIcon from "@mui/icons-material/Add";
import PublishIcon from "@mui/icons-material/Publish";
import { CreateElectionEventProvider, useCreateElectionEventStore, } from "@/providers/CreateElectionEventContextProvider";
import { CreateDataDrawer } from "@/components/election-event/create/CreateElectionEventDrawer";
import { ImportDataDrawer } from "@/components/election-event/import-data/ImportDataDrawer";
var EmptyBox = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    width: 100%;\n"], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    width: 100%;\n"])));
var CenteredBox = styled(Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    text-align: center;\n"], ["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    text-align: center;\n"])));
export var ElectionEventListContent = function (_a) {
    var aside = _a.aside;
    var t = useTranslation().t;
    var navigate = useNavigate();
    var pathname = useLocation().pathname;
    var tenantId = useTenantStore()[0];
    var authContext = useContext(AuthContext);
    var isArchivedElectionEvents = useAtom(archivedElectionEventSelection)[0];
    var canCreateElections = authContext.isAuthorized(true, tenantId, IPermissions.ELECTION_EVENT_WRITE);
    var _b = useCreateElectionEventStore(), openCreateDrawer = _b.openCreateDrawer, openImportDrawer = _b.openImportDrawer;
    var _c = useGetList("sequent_backend_election_event", {
        sort: { field: "created_at", order: "DESC" },
        filter: {
            tenant_id: tenantId,
            is_archived: isArchivedElectionEvents,
        },
    }, {
        enabled: false,
    }), data = _c.data, isLoading = _c.isLoading, refetch = _c.refetch;
    // Reload data when the path changes
    useEffect(function () {
        refetch();
    }, [pathname]);
    // if data, we would be automatically redirected to the first election
    // event, so we should just show a process icon in the meantime
    useEffect(function () {
        var _a;
        if (data && data.length > 0) {
            var electionEventId = (_a = data[0].id) !== null && _a !== void 0 ? _a : null;
            if (electionEventId) {
                navigate("/sequent_backend_election_event/" + electionEventId);
            }
        }
        else {
            navigate("/sequent_backend_election_event");
        }
    }, [data]);
    return (_jsx(CenteredBox, { children: isLoading ? (_jsx(CircularProgress, {})) : (_jsxs(_Fragment, { children: [_jsxs(EmptyBox, __assign({ m: 1 }, { children: [_jsx(Typography, __assign({ variant: "h4", paragraph: true }, { children: t("electionEventScreen.error.noResult") })), canCreateElections ? (_jsxs(_Fragment, { children: [_jsx(Typography, __assign({ variant: "body1", paragraph: true }, { children: t("common.resources.noResult.askCreate") })), _jsxs(Box, __assign({ display: "flex", gap: 1 }, { children: [_jsx(Button, { label: t("common.label.add"), startIcon: _jsx(AddIcon, {}), onClick: function () { return openCreateDrawer(); } }), _jsx(Button, { label: t("common.label.import"), startIcon: _jsx(PublishIcon, {}), onClick: function () { return openImportDrawer === null || openImportDrawer === void 0 ? void 0 : openImportDrawer(); } })] }))] })) : null] })), _jsx(CreateDataDrawer, {}), _jsx(ImportDataDrawer, { title: "electionEventScreen.import.eetitle", subtitle: "electionEventScreen.import.eesubtitle", paragraph: "electionEventScreen.import.electionEventParagraph" })] })) }));
};
export var ElectionEventList = function (props) { return (_jsx(CreateElectionEventProvider, { children: _jsx(ElectionEventListContent, __assign({}, props)) })); };
var templateObject_1, templateObject_2;
